import { api, apiDev } from "./api";

interface TenantMallApiResponse {
    tenantMallDatas: {
        TenantId: number;
        BrandId: number;
        BrandName: string;
        MallId: number;
        MallName: string;
        Floor: string;
        Unit: string;
        Address: string;
        PICName: string;
        PICPhone: string;
        PICEmail: string;
        Status: number;
    }[];
    TotalRecord: number;
    Code: number;
    Message: string;
}

interface VendorSyncPayload {
    TenantId: number;
    PICName: string;
    PICPhone: string;
    PICEmail: string;
    Address: string;
    TenantName: string;
    Unit: string;
    ModifiedBy: string;
    CreatedBy: string;
    Notes?: string;
}

interface VendorSyncApiResponse {
    TenantRegistrationId?: number;
    TenantNewId?: string | null;
    Code: number;
    Message: string;
}

interface VendorSyncDatasResponse {
    VendorSyncDatas: {
        TenantRegistrationId: number;
        TenantId: number;
        TenantNewId: string;
        PICName: string;
        PICPhone: string;
        PICEmail: string;
        VendorNetId: number;
        Address: string;
        TenantName: string;
        Unit: string;
        Status: number;
        ModifiedOn: string;
        ModifiedBy: string;
        CreatedOn: string;
        CreatedBy: string;
        Notes?: string;
    }[];
    TotalRecord: number;
    Code: number;
    Message: string;
}

export const GetTenantMall = async (tenantId: number, number: number, page: number): Promise<TenantMallApiResponse | null> => {
    try {
        if (!tenantId || tenantId === 0) {
            return null;
        }

        const url = `/tenant/v1/gettenantmall?tenantid=${tenantId}&number=${number}&page=${page}`;
        const response = await apiDev.get<TenantMallApiResponse>(url);

        if (response.status === 200 && response.data) {
            return response.data;
        }

    } catch (error) {
        console.log(error);
    }
    return null;
};

export const SaveVendorSync = async (payload: Omit<VendorSyncPayload, "TenantId" | "ModifiedBy" | "CreatedBy">): Promise<VendorSyncApiResponse | null> => {
    try {
        const tenantId = parseInt(
            localStorage.getItem("tenant_id") ||
            sessionStorage.getItem("tenant_id") ||
            "0"
        );

        if (!tenantId || tenantId === 0) {
            console.log("tenant_id not valid:", tenantId);
            return null;
        }

        const userEmail =
            localStorage.getItem("user_email") ||
            sessionStorage.getItem("user_email") ||
            "Admin";

        const body = {
            vendorSyncData: {
                ...payload,
                TenantId: tenantId,
                ModifiedBy: userEmail,
                CreatedBy: userEmail,
            } satisfies VendorSyncPayload,
        };

        const response = await apiDev.post<VendorSyncApiResponse>("/tenant/v1/savevendorsync", body);

        if (response.status === 200 && response.data) {
            return response.data;
        }

    } catch (error) {
        console.log(error);
    }
    return null;
};

export const GetVendorSyncDatas = async (): Promise<VendorSyncDatasResponse | null> => {
    try {
        const tenantId = parseInt(
            localStorage.getItem("tenant_id") ||
            sessionStorage.getItem("tenant_id") ||
            "0"
        );

        if (!tenantId || tenantId === 0) {
            console.log("tenant_id not valid:", tenantId);
            return null;
        }

        const response = await apiDev.get<VendorSyncDatasResponse>(`/tenant/v1/getvendortenant/${tenantId}`);

        if (response.status === 200 && response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
    return null;
};

export interface VendorSyncHistoryData {
    TenantRegistrationId: number;
    TenantId: number;
    TenantNewId: string;
    PICName: string;
    PICPhone: string;
    PICEmail: string;
    VendorNetId: number;
    Address: string;
    TenantName: string;
    Unit: string;
    Status: number;
    ModifiedOn: string;
    ModifiedBy: string;
    CreatedOn: string;
    CreatedBy: string;
    Notes?: string;
}

export interface RegistrationHistoryResponse {
    VendorSyncHistoryDatas: VendorSyncHistoryData[];
    TotalRecord: number;
    Code: number;
    Message: string;
}

export const GetRegistrationHistory = async (tenantId: number): Promise<RegistrationHistoryResponse | null> => {
    try {
        if (!tenantId || tenantId === 0) {
            console.log("tenant_id not valid:", tenantId);
            return null;
        }

        const response = await apiDev.get<RegistrationHistoryResponse>(`/tenant/v1/getlistregistration?tenantid=${tenantId}`);

        if (response.status === 200 && response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
    return null;
};

export interface BrandDetailData {
    TenantId: number;
    BrandId: number;
    BrandName: string;
    MallId: number;
    MallName: string;
    Floor: string;
    Unit: string;
    Area: number;
    BrandCategoryId: number;
    BrandCategoryName: string;
    BrandMainCategoryId: number;
    MainCategory: string;
    CapacityLabel: string;
    Status: number;
}

export interface GetBrandResponse {
    brandDetailDatas: BrandDetailData[];
    TotalRecord: number;
    Code: number;
    Message: string;
}

export const GetBrandDev = async (tenantId: number): Promise<GetBrandResponse | null> => {
    try {
        if (!tenantId || tenantId === 0) {
            return null;
        }
        const url = `/brand/v1/getbrand?brandid=0&tenantid=${tenantId}&number=0&page=0`;
        const response = await api.get<GetBrandResponse>(url);
        if (response.status === 200 && response.data) {
            return response.data;
        }
    } catch (error) {
        console.log("Error in GetBrandDev:", error);
    }
    return null;
};